/* tslint:disable */
/* eslint-disable */
/**
 * EVE Swagger Interface
 * An OpenAPI for EVE Online
 *
 * The version of the OpenAPI document: 1.30
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 200 ok object
 * @export
 * @interface GetCharactersCharacterIdOk
 */
export interface GetCharactersCharacterIdOk {
    /**
     * The character's alliance ID
     * @type {number}
     * @memberof GetCharactersCharacterIdOk
     */
    allianceId?: number;
    /**
     * Creation date of the character
     * @type {Date}
     * @memberof GetCharactersCharacterIdOk
     */
    birthday: Date;
    /**
     * bloodline_id integer
     * @type {number}
     * @memberof GetCharactersCharacterIdOk
     */
    bloodlineId: number;
    /**
     * The character's corporation ID
     * @type {number}
     * @memberof GetCharactersCharacterIdOk
     */
    corporationId: number;
    /**
     * description string
     * @type {string}
     * @memberof GetCharactersCharacterIdOk
     */
    description?: string;
    /**
     * ID of the faction the character is fighting for, if the character is enlisted in Factional Warfare
     * @type {number}
     * @memberof GetCharactersCharacterIdOk
     */
    factionId?: number;
    /**
     * gender string
     * @type {string}
     * @memberof GetCharactersCharacterIdOk
     */
    gender: GetCharactersCharacterIdOkGenderEnum;
    /**
     * name string
     * @type {string}
     * @memberof GetCharactersCharacterIdOk
     */
    name: string;
    /**
     * race_id integer
     * @type {number}
     * @memberof GetCharactersCharacterIdOk
     */
    raceId: number;
    /**
     * security_status number
     * @type {number}
     * @memberof GetCharactersCharacterIdOk
     */
    securityStatus?: number;
    /**
     * The individual title of the character
     * @type {string}
     * @memberof GetCharactersCharacterIdOk
     */
    title?: string;
}


/**
 * @export
 */
export const GetCharactersCharacterIdOkGenderEnum = {
    Female: 'female',
    Male: 'male'
} as const;
export type GetCharactersCharacterIdOkGenderEnum = typeof GetCharactersCharacterIdOkGenderEnum[keyof typeof GetCharactersCharacterIdOkGenderEnum];


/**
 * Check if a given object implements the GetCharactersCharacterIdOk interface.
 */
export function instanceOfGetCharactersCharacterIdOk(value: object): value is GetCharactersCharacterIdOk {
    if (!('birthday' in value) || value['birthday'] === undefined) return false;
    if (!('bloodlineId' in value) || value['bloodlineId'] === undefined) return false;
    if (!('corporationId' in value) || value['corporationId'] === undefined) return false;
    if (!('gender' in value) || value['gender'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('raceId' in value) || value['raceId'] === undefined) return false;
    return true;
}

export function GetCharactersCharacterIdOkFromJSON(json: any): GetCharactersCharacterIdOk {
    return GetCharactersCharacterIdOkFromJSONTyped(json, false);
}

export function GetCharactersCharacterIdOkFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetCharactersCharacterIdOk {
    if (json == null) {
        return json;
    }
    return {
        
        'allianceId': json['alliance_id'] == null ? undefined : json['alliance_id'],
        'birthday': (new Date(json['birthday'])),
        'bloodlineId': json['bloodline_id'],
        'corporationId': json['corporation_id'],
        'description': json['description'] == null ? undefined : json['description'],
        'factionId': json['faction_id'] == null ? undefined : json['faction_id'],
        'gender': json['gender'],
        'name': json['name'],
        'raceId': json['race_id'],
        'securityStatus': json['security_status'] == null ? undefined : json['security_status'],
        'title': json['title'] == null ? undefined : json['title'],
    };
}

export function GetCharactersCharacterIdOkToJSON(json: any): GetCharactersCharacterIdOk {
    return GetCharactersCharacterIdOkToJSONTyped(json, false);
}

export function GetCharactersCharacterIdOkToJSONTyped(value?: GetCharactersCharacterIdOk | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'alliance_id': value['allianceId'],
        'birthday': ((value['birthday']).toISOString()),
        'bloodline_id': value['bloodlineId'],
        'corporation_id': value['corporationId'],
        'description': value['description'],
        'faction_id': value['factionId'],
        'gender': value['gender'],
        'name': value['name'],
        'race_id': value['raceId'],
        'security_status': value['securityStatus'],
        'title': value['title'],
    };
}

